import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class zAppDevSubscriptionConfig  {
    _originalTypeClassName = "zPMO.BO.zAppDevSubscriptionConfig";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
zAppDevSubscriptionConfig.translate = translateService;
}
this.Days = [];
this.Products = [];
this.Id = null;
this.EnableExpiringNotification = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
EnableExpiringNotification:any;
Days:any;
Products:any;
static setDays = ($this, items) => {
                if (items == null) items = [];
                if ($this.Days == null) $this.Days = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Days.length > 0) {
                    Domain.zAppDevSubscriptionConfig.removeDays($this, $this.Days[0]);
                }

                Domain.zAppDevSubscriptionConfig.addManyDays($this, copyItems);
            }
static addManyDays = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.zAppDevSubscriptionConfig.addDays($this, items[i]);
                }
            }
static addDays = ($this, item) => {
                if ($this.Days == null) $this.Days = [];
                if (item == null || $this.Days.indexOf(item) > -1) return;
                $this.Days.push(item);
}
static addRangeDays = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.zAppDevSubscriptionConfig.addDays($this, item));
            }
static removeDays = ($this, item) => {
                if ($this == null || $this.Days == null || $this.Days.indexOf(item) === -1) return;
                var _index = $this.Days.indexOf(item);
                $this.Days.splice(_index, 1);
}
static clearDays = ($this) => { $this.Days = null; }
static setProducts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Products == null) $this.Products = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Products.length > 0) {
                    Domain.zAppDevSubscriptionConfig.removeProducts($this, $this.Products[0]);
                }

                Domain.zAppDevSubscriptionConfig.addManyProducts($this, copyItems);
            }
static addManyProducts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.zAppDevSubscriptionConfig.addProducts($this, items[i]);
                }
            }
static addProducts = ($this, item) => {
                if ($this.Products == null) $this.Products = [];
                if (item == null || $this.Products.indexOf(item) > -1) return;
                $this.Products.push(item);
}
static addRangeProducts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.zAppDevSubscriptionConfig.addProducts($this, item));
            }
static removeProducts = ($this, item) => {
                if ($this == null || $this.Products == null || $this.Products.indexOf(item) === -1) return;
                var _index = $this.Products.indexOf(item);
                $this.Products.splice(_index, 1);
}
static clearProducts = ($this) => { $this.Products = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}